<template>
  <div class="landing">
    <div class="main-container">
      <div class="login-card-wrap">
        <div class="card border-0 shadow">
          <div class="card-body p-4">
            <h3 class="text-center">Login</h3>
            <form @submit.prevent="proceedToLogin()" class="d-flex flex-column">
              <div class="d-flex gap-3 mb-3" v-if="loginMethods.length > 1">
                <div v-for="method in loginMethods" :key="method.key" class="d-flex align-items-center gap-2">
                  <input type="radio" :id="method.key" :class="showOtp ? '' : 'cursor-pointer'" :value="method.key"
                    v-model="selectedMethod" :disabled="showOtp" />
                  <label :for="method.key" :class="showOtp ? '' : 'cursor-pointer'">{{ method.label }}</label>
                </div>
              </div>
              <div class="">
                <label class="form-header mb-1">
                  {{ getLabel(selectedMethod) }} <text class="mandatory-mark">*</text>
                </label>

                <input :type="getInputType(selectedMethod)" class="form-control" v-model="formData[selectedMethod]"
                  :placeholder="getPlaceholder(selectedMethod)" :disabled="showOtp"
                  @blur="onLoginIdBlur" />

                <label class="errormsg">{{ errormsg }}</label>
              </div>
              <div class="">
                <label class="form-header" for="floatingPassword">Password <text class="mandatory-mark">*</text></label>
                <input :type="show ? 'text' : 'password'" class="form-control" v-model="password" autocomplete="off"
                  id="floatingPassword" placeholder="Password" :disabled="showOtp" />
              </div>
              <div class="d-flex align-items-center gap-2 mt-3 mb-3">
                <input type="checkbox" class="m-0" @change="showPassword()" id="showPass" :disabled="showOtp" />
                <label class="mb-0" style="font-size: 12px;" for="showPass">Show Password</label>
              </div>

              <div class="mb-3" v-if="showOtp">
                <label class="form-header" for="floatingInput"> Enter your OTP </label>
                <input type="text" class="form-control" v-model="otp" id="floatingInput"
                  placeholder="Please enter your otp here" maxlength="6" @keypress="isNumber($event)" />
                <span v-if="otpSent" style="font-size:14px"> {{ otpSent }} </span>
                <div v-if="otpSent">Still didn’t get the OTP? <strong class="cursor-pointer text-decoration-underline"
                    @click="proceedToLogin(true)">Resend New OTP by clicking here.</strong></div>
                <label v-if="errormsg" class="errormsg mt-2">{{ errormsg }}</label>
              </div>
              <span class="errormsg mb-3" v-if="errormsglogin">{{ errormsglogin }}</span>
              <div class="d-grid">
                <button class="btn btn-primary btn-login text-uppercase fw-bold" type="submit"
                  :disabled="isButtonDisabled">{{ getButtonText }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jwt_decode from "jwt-decode";
import { getConsumer, getDistributer } from '@/mixins/common';
import { trimEdges } from '@/utils/inputSanitizer';

export default {
  name: "loginpage",
  data() {
    return {
      email: "",
      password: "",
      show: false,
      errormsg: "",
      errormsglogin: "",
      token: "",
      decoded: "",
      current_user: "",
      OTPTransactionId: "",
      otpExpiryTime: "",
      showOtp: false,
      otp: "",
      intervalId: null,
      loading: false,
      otpSent: "",
      loginMethods: [
        { key: "userName", label: "User Id", type: "text", placeholder: "Enter your user id" },
      ],
      selectedMethod: "userName",
      formData: {
        email: "",
        mobile: "",
        userName: "",
      },
      loginAuthTypes: [],
      transId: '',
    };
  },

  mounted() {
    if (this.$store.state.token) {
      this.$router.go(-1);
    }
    this.loginAuthTypes = getConsumer()?.loginAuthTypes || [];
  },

  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showPassword() {
      this.show = !this.show;
    },
    onLoginIdBlur() {
      const key = this.selectedMethod;
      if (typeof this.formData[key] === 'string') {
        this.formData[key] = trimEdges(this.formData[key]);
      }
    },
    validateEmail() {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,64})+$/.test(this.formData[this.selectedMethod]);
    },
    async proceedToLogin(retry = false) {
      this.onLoginIdBlur();
      if (this.loginAuthTypes.length === 2) {
        if (this.showOtp && !retry) {
          await this.handleLogin(this.loginAuthTypes[1]);
        } else {
          await this.handleLogin(this.loginAuthTypes[0]);
        }
      } else {
        await this.handleLogin(this.loginAuthTypes[0]);
      }
    },

    async handleLogin(authUsing) {
      this.onLoginIdBlur();
      if (!this.formData[this.selectedMethod]) {
        this.errormsg = `Please enter ${this.selectedMethod}`;
        return;
      }
      if (!this.password && authUsing !== "2FactorAuth") {
        this.errormsglogin = "Please enter password";
        return;
      }
      if (this.selectedMethod === "email" && !this.validateEmail()) {
        this.errormsg = "Please enter a valid email address";
        return;
      }

      this.errormsg = "";
      this.errormsglogin = "";
      this.loading = true;

      const distributorId = getConsumer()?.consumerId || getDistributer()?.distributerID || "";

      const qData = {
        distributorID: distributorId,
        insuranceCompanyCode: "TATA",
        authUsing,
        password: this.password || "",
        OTPTransactionId: this.OTPTransactionId || "",
        OTP: this.otp || "",
        UITrackingRefNo: "",
        email: "",
        mobile: "",
        userName: ""
      };

      qData[this.selectedMethod] = this.formData[this.selectedMethod];

      try {
        const response = await this.backendApi("userLogin", qData, {});

        if (response === "error") {
          this.apiError = true;
          this.loading = false;
          return;
        }

        if (response?.data) {
          const { errors, data } = response.data;
          const errorList = Array.isArray(errors) ? errors : errors?.errors ?? [];
          const displayMessage =
            errors?.data?.reason || errorList[0]?.errorDisplayMessage;

          if (authUsing === "2FactorAuth" && errors?.data?.OTPAccepted == 'No') {
            this.errormsglogin = displayMessage;
            return;
          }

          if (errorList.length === 0) {
            if (authUsing === "basicAuthOtp") {
              this.OTPTransactionId = data.OTPTransactionId;
              this.otpExpiryTime = data.ExpiryTime;
              this.showOtp = true;
              this.startCountdown?.();
            } else if (["2FactorAuth", "basicAuth"].includes(authUsing)) {
              this.token = data.token.access_token;
              this.$store.commit("setToken", this.token);

              try {
                const decoded = jwt_decode(this.token);
                this.transId = decoded?.PAYLOAD?.transactionId || "";
                if (this.transId) {
                  this.$router.push(`/?id=${this.transId}`);
                } else {
                  this.$router.push('/');
                }
              } catch (err) {
                console.error("Failed to decode token:", err);
                this.$router.push('/');
              }
            }
          } else if (displayMessage) {
            this.errormsglogin = displayMessage;
          }
        }
      } catch (error) {
        console.error("Login request failed:", error);
      } finally {
        this.loading = false;
      }
    },
    getInputType(method) {
      const config = this.loginMethods.find(m => m.key === method);
      return config ? config.type : "text";
    },
    getPlaceholder(method) {
      const config = this.loginMethods.find(m => m.key === method);
      return config ? config.placeholder : "";
    },
    getLabel(method) {
      const config = this.loginMethods.find(m => m.key === method);
      return config ? config.label : "";
    },
  },
  computed: {
    getButtonText() {
      if (this.loading && !this.showOtp) {
        return "Signing In...";
      }
      if (this.loading && this.showOtp) {
        return "Validating OTP..."
      }
      if (this.showOtp) {
        return "Validate Otp"
      }
      return "Sign In"
    },
    isButtonDisabled() {
      if (this.loading) {
        return true;
      }
      return (!this.showOtp && (!this.formData[this.selectedMethod] || !this.password)) || (this.showOtp && this.otp.length !== 6);
    },
    startCountdown() {
      const otpExpiry = new Date(this.otpExpiryTime);
      clearInterval(this.intervalId);
      this.intervalId = setInterval(() => {
        const currentTime = new Date();
        const timeDifference = otpExpiry - currentTime;
        if (timeDifference > 0) {
          if (timeDifference >= 60000) {
            const minutesRemaining = Math.floor(timeDifference / (1000 * 60));
            this.otpSent = `OTP has been sent successfully to your registered mobile number/email ID and will be valid for the next ${minutesRemaining} mins.`;
          } else {
            const secondsRemaining = Math.floor(timeDifference / 1000);
            this.otpSent = `OTP has been sent successfully to your registered mobile number/email ID and will be valid for the next ${secondsRemaining} secs.`;
          }
        } else {
          clearInterval(this.intervalId);
          this.otpSent = "OTP has expired.";
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/scss/components/loginpage.scss";
</style>
